import React from 'react';

const RING = 2 * Math.PI * 46;

// Ellie's presence: a softly morphing orb. `mood` drives its animation
// (idle breathing, faster thinking, a burst when done); `progress` 0–1 draws a ring around it.
const Orb = ({ size = 44, mood = 'idle', progress = null }) => (
  <div className={`v2-orb v2-orb--${mood}`} style={{ width: size, height: size }} aria-hidden="true">
    {progress !== null && (
      <svg className="v2-orb__ring" viewBox="0 0 100 100">
        <circle className="v2-orb__track" cx="50" cy="50" r="46" />
        <circle
          className="v2-orb__bar"
          cx="50"
          cy="50"
          r="46"
          strokeDasharray={RING}
          strokeDashoffset={RING * (1 - Math.max(0, Math.min(1, progress)))}
        />
      </svg>
    )}
    <div className="v2-orb__glow" />
    <div className="v2-orb__core" />
  </div>
);

export default Orb;
